<template>
  <section class="section">
    <div class="container items-center">
      <h3 class="section--h3 mb-base">Successful Implementors</h3>
      <!--<p class="section__p mb-base">Activate Organization Mode to see how GetBoarded can help you and your employees to manage career choices keeping future in mind. A talent management tool with features that will convince you to use it as SaaS for your business.</p>-->
      <vs-row vs-type="flex">
        <vs-col class="sm:w-full lg:w-1/3 p-5"  vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"

              >
                <img class="implementor-img img-fluid" src="../../../../../src/assets/images/pages/alex/imp1.png" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Axonify</h4>
              <p class="feature-description mb-5">Designed a microlearning platform with Walmart to increase employee’s knowledge & retention regarding safety practices. It resulted in a 15% increase in employee knowledge that led to a 54% decrease in recordable safety incidents!</p>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/3 p-5"  vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"

              >
                <img class="implementor-img img-fluid" src="../../../../../src/assets/images/pages/alex/imp2.png" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">IBM</h4>
              <p class="feature-description mb-5">IBM Micro Learning helps IT developers and professionals quickly gain experience on a specific topic. The new IBM Cloud labs present exercises in bite-sized format.</p>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/3 p-5"  vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"

              >
                <img class="implementor-img img-fluid" src="../../../../../src/assets/images/pages/alex/imp3.png" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Alertdriving</h4>
              <p class="feature-description mb-5">The increased flexibility of micro-learning translates into a more effective, engaging and enjoyable user experience, since it reduces the cognitive load on today’s busy and time-sensitive learners</p>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Implementors",
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }

  button {
    border-radius: 50px;
  }

  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    width: 65%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    /* or 150% */
    text-align: center;
    color: #848199;
  }

  /*===============================================*/
  /* PERSONALITY	 						 */
  /*===============================================*/

  .leaf {
    position: absolute;
    left: 0;
    top: 0;
    width: 500px;
  }

  .personality-row {
    /*margin-top: 10rem;*/
    width: 85%!important;
  }

  .personality-card {
    min-height: 440px;
    z-index: 999;
    box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  }

  .feature-title {
    font-style: normal;
    font-weight: 900;
    font-size: 26px;
    line-height: 36px;
    text-align: center;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .implementor-img {
    max-height: 100px;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 0;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf {
      width: -webkit-fill-available;
      width: -moz-available;
    }
  }
</style>
